/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateAwsKmsKeyRequestBody = {
  /**
   * Optional. The AWS principal ARN the customer granted on the key in its key policy. Not a secret.
   */
  customerGrantReference?: string | undefined;
  /**
   * The external credential Speakeasy uses to authenticate to the key. Must be an aws_iam credential belonging to the same organization.
   */
  externalCredentialId: string;
  /**
   * The ID of the key to update.
   */
  id: string;
  /**
   * A human-readable name for the key.
   */
  name: string;
};

/** @internal */
export type UpdateAwsKmsKeyRequestBody$Outbound = {
  customer_grant_reference?: string | undefined;
  external_credential_id: string;
  id: string;
  name: string;
};

/** @internal */
export const UpdateAwsKmsKeyRequestBody$outboundSchema: z.ZodMiniType<
  UpdateAwsKmsKeyRequestBody$Outbound,
  UpdateAwsKmsKeyRequestBody
> = z.pipe(
  z.object({
    customerGrantReference: z.optional(z.string()),
    externalCredentialId: z.string(),
    id: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      customerGrantReference: "customer_grant_reference",
      externalCredentialId: "external_credential_id",
    });
  }),
);

export function updateAwsKmsKeyRequestBodyToJSON(
  updateAwsKmsKeyRequestBody: UpdateAwsKmsKeyRequestBody,
): string {
  return JSON.stringify(
    UpdateAwsKmsKeyRequestBody$outboundSchema.parse(updateAwsKmsKeyRequestBody),
  );
}
